import React, { useEffect, useState } from "react";
import LcIconLink from "../LcIconLink";
import "./index.css";
import SolicitationCommentService from "../../../services/SolicitationCommentService/SolicitationCommentService";
import GenerativeIaEvaluationService from "../../../services/GenerativeIaEvaluationService/GenerativeIaEvaluationService";
import LcLoading from "../LcLoading";
import AlertNotification, { AlertColor } from "../../Dialog/AlertNotification";
import { IoSparklesSharp } from "react-icons/io5";
import { MenuState } from "../../../store/reducers/menuReducer";
import { RootState } from "../../../store/index";
import { useSelector } from "react-redux";
import moment from "moment";
import { BsFillInfoCircleFill } from "react-icons/bs";
import LcTooltip from "../LcTooltip";
import ContentEditable from "react-contenteditable";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

interface Props {
    title?: string,
    originalText: string,
    close: Function,
    visible: boolean,
    width?: string
    height?: string
    handleVisible: Function
    setText: Function
    user: any
    solicitation: any
    showToolBar: boolean
    comments?: any[]
    setVisible: Function
}

const HHCommentSumarization: React.FC<Props> = (props) => {
    const generativeIaEvaluationService = new GenerativeIaEvaluationService(props);
    const [summary, setSummary] = useState<any>();
    const [summaryText, setSummaryText] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [severity, setSeverity] = useState<AlertColor>("info");
    const [message, setMessage] = useState<string>("");
    const [openNotificacao, setOpenNotificacao] = useState<boolean>(false);
    const menu = useSelector<RootState, MenuState>(state => state.menu);
    const [newComments, setNewComments] = useState<any[]>([]);
    const [disabled, setDisabled] = useState<boolean>(true);

    useEffect(() => {
        if (props.visible) {
            getSummary();
        }
    }, [props.visible]);

    useEffect(() => {
        checkCommentListDate();
    }, [props.comments, summary]);

    const getSummary = async () => {
        setLoading(true);

        try {
            const response = await generativeIaEvaluationService.GetGenerativeIaEvaluationList(props.solicitation.id);
            var commentSummary = response.data.filter(x => x.recordType == 1);

            if (commentSummary.length > 0) {
                var textString = JSON.stringify(commentSummary[0].text).replaceAll("\\n", "<br>");
                var _text = JSON.parse(textString);
                setSummaryText(_text);
                setSummary(commentSummary[0]);
                setDisabled(true);
            }
            else {
                await setNewSummary();
            }
        }
        catch (error) {
            debugger
        }

        setLoading(false);
    }

    const setNewSummary = async () => {
        setLoading(true);

        try {
            var solicitationSumarizeRequest = {
                idSolicitation: props.solicitation.id,
                idUser: props.user.id,
                recordType: 1,
            }

            await generativeIaEvaluationService.SetCommentSummary(solicitationSumarizeRequest);
            await getSummary();
        }
        catch (error) {
            debugger
        }

        setLoading(false);
    }

    const saveNewSummary = async () => {
        setLoading(true);

        try {
            const _summary = {
                ...summary,
                Prompt: summaryText
            }

            await generativeIaEvaluationService.SetNewCommentSumary(_summary);
            await getSummary();
        }
        catch (error) {
            debugger
        }

        setLoading(false);
    }

    const checkCommentListDate = () => {
        if (summary && props.comments && props.comments.length > 0) {
            var _newComments = props.comments.filter(x => x.commentDate > summary.generatedDate);
            setNewComments(_newComments);
        }
    }

    const copyToClipbord = () => {
        var textString = JSON
            .stringify(summaryText)
            .replaceAll("<br>", "\\n")
            .replaceAll("<br />", "\\n")
            .replaceAll("<br/>", "\\n");
        var _text = JSON.parse(textString);
        navigator.clipboard.writeText(_text);

        setMessage(`Texto copiado com sucesso`);
        setSeverity("success");
        setOpenNotificacao(true);
        setTimeout(() => setOpenNotificacao(false), 2000);
    };

    const handleClickAway = () => {
        if (props.visible && props.setVisible) {
            props.setVisible(false);
        }
    };

    const handleDisable = () => {
        setDisabled(!disabled);
        var textString = JSON.stringify(summary.text).replaceAll("\\n", "<br>");
        var _text = JSON.parse(textString);
        setSummaryText(_text);
    }

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <div className={"sumarization-modal"}>
                <AlertNotification open={openNotificacao} severity={severity} message={message} handleClose={() => setOpenNotificacao(false)} />
                {
                    props.visible &&
                    <div className={"all"}
                        style={{
                            left: (menu.toggle) ? "100px" : "280px",
                            bottom: (props.showToolBar) ? "220px" : "80px",
                            transition: 'left 0.5s ease 0s'
                        }}>
                        <div className={"content"}>
                            <div className={"body"}>
                                <>
                                    <div className={"div-title-originalText"}>
                                        <div className={"title-originalText"}>
                                            <div>
                                                <IoSparklesSharp />
                                                <span style={{ paddingLeft: "10px" }}>Sumarização</span>
                                            </div>

                                            <LcIconLink icon='ppi ppi-x' tooltip='Fechar' onClick={() => props.close(false)} />
                                        </div>
                                        {/* <LcIconLink icon={"ppi ppi-x"} tooltip={"Fechar"} onClick={() => props.close(false)} /> */}
                                        {
                                            !loading && newComments.length > 0 &&
                                            <div style={{ display: "flex" }}>
                                                <LcTooltip content={`${newComments.length} comentário(s) adicionado(s) desde a última sumarização`} position={"top"} trigger={"hover"}>
                                                    <BsFillInfoCircleFill size="18px" color={"#ebeb22"} />
                                                </LcTooltip>
                                                {/* <LcIconLink icon={"ppi ppi-x"} tooltip="Fechar" onClick={() => props.setVisible(false)} /> */}
                                            </div>
                                        }
                                        {
                                            // newComments.length == 0 &&
                                            // <LcIconLink icon={"ppi ppi-x"} tooltip="Fechar" onClick={() => props.setVisible(false)} /> 
                                        }
                                    </div>
                                    <LcLoading label={"Carregando..."} loading={loading} height={"150px"} width={"450px"}>
                                        {
                                            disabled
                                                ? <div
                                                    id={"AiText"}
                                                    className={`AiText ${disabled ? "disabled" : ""}`}
                                                    dangerouslySetInnerHTML={{ __html: summaryText }}
                                                />
                                                : <ContentEditable
                                                    html={summaryText}
                                                    className={"AiText"}
                                                    id={"AiText"}
                                                    onChange={(e) => {
                                                        var textString = JSON.stringify(e.target.value).replaceAll("\\n", "<br>");
                                                        var _text = JSON.parse(textString);
                                                        setSummaryText(_text)
                                                    }}
                                                />
                                        }
                                    </LcLoading>
                                </>
                                <>
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        <div className={"title-sugestao"}>
                                        </div>
                                        {
                                            // !loadingSugggestion && totalTokens > 0 &&
                                            // <span style={{ marginLeft: "5px" }}>Total de tokens usados: {totalTokens}</span>
                                        }
                                    </div>
                                </>
                                {
                                    <>
                                        {
                                            !loading &&
                                            <div style={{
                                                display: "flex",
                                                justifyContent: (summaryText != "") ? "space-between" : "flex-end",
                                                alignItems: "center",
                                                marginTop: "10px",
                                                height: "40px"
                                            }}>
                                                <>
                                                    {
                                                        summaryText != "" &&
                                                        <>
                                                            <div className={"btn-wrapper"}>
                                                                <LcIconLink
                                                                    icon={"ppi ppi-clipboard"}
                                                                    size={"small"}
                                                                    tooltip={"Copiar"}
                                                                    onClick={() => copyToClipbord()}
                                                                />
                                                                <LcIconLink
                                                                    icon={"ppi ppi-refresh"}
                                                                    size={"small"}
                                                                    tooltip={"Gerar sumário novamente"}
                                                                    onClick={() => setNewSummary()}
                                                                    disabled={!disabled}
                                                                />
                                                                <LcIconLink
                                                                    icon={"ppi ppi-pencil-alt"}
                                                                    size={"small"}
                                                                    tooltip={"Editar"}
                                                                    activedAfterClick={!disabled}
                                                                    onClick={() => handleDisable()}
                                                                />
                                                            </div>

                                                            <>
                                                                {
                                                                    disabled
                                                                        ? <div
                                                                            style={{
                                                                                fontSize: "11.5px",
                                                                                color: "grey",
                                                                                display: "flex",
                                                                                flexDirection: "column",
                                                                                alignItems: "flex-end"
                                                                            }}>
                                                                            <span>Gerado em {moment(summary && summary.generatedDate).format("DD/MM/YYYY - HH:mm")}</span>
                                                                            <span>por {summary && summary.nameUser}</span>
                                                                        </div>
                                                                        : <button className={"lc-button bg-info"} onClick={() => saveNewSummary()}>Salvar Alterações</button>
                                                                }
                                                            </>
                                                            {/* <div
                                                                style={{
                                                                    fontSize: "11.5px",
                                                                    color: "grey",
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    alignItems: "flex-end"
                                                                }}>
                                                                <span>Gerado em {moment(summary.generatedDate).format("DD/MM/YYYY - HH:mm")}</span>
                                                                <span>por {summary.nameUser}</span>
                                                            </div> */}
                                                        </>
                                                        // : <button className={"lc-button bg-info"} onClick={() => setNewSummary()}>Gerar sumário</button>
                                                    }
                                                </>
                                            </div>
                                        }
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
        </ClickAwayListener>
    );
}

export default HHCommentSumarization;